import { en } from "./en";
import { privacyEn } from "./privacy.en";
import { privacyZh } from "./privacy.zh";
import { privacyZhHant } from "./privacy.zh-Hant";
import { supportEn } from "./support.en";
import { supportZh } from "./support.zh";
import { supportZhHant } from "./support.zh-Hant";
import { termsEn } from "./terms.en";
import { termsZh } from "./terms.zh";
import { termsZhHant } from "./terms.zh-Hant";
import type { LandingContent, Locale, PrivacyContent, SupportContent, TermsContent } from "./types";
import { zh } from "./zh";
import { zhHant } from "./zh-Hant";

// 显式标成 Record<Locale, …>：以后再加语言，漏补哪张表 TypeScript 会直接报错。
export const landingByLocale: Record<Locale, LandingContent> = {
  en,
  zh,
  "zh-Hant": zhHant
};

export const privacyByLocale: Record<Locale, PrivacyContent> = {
  en: privacyEn,
  zh: privacyZh,
  "zh-Hant": privacyZhHant
};

export const supportByLocale: Record<Locale, SupportContent> = {
  en: supportEn,
  zh: supportZh,
  "zh-Hant": supportZhHant
};

export const termsByLocale: Record<Locale, TermsContent> = {
  en: termsEn,
  zh: termsZh,
  "zh-Hant": termsZhHant
};
